var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFerienhaus = function SvgFerienhaus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Ferienhaus")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ferienhaus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-house-chimney-2@24x24",
    transform: "translate(35.000000, 38.000000)",
    stroke: "#212121",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,44 L10,74 L31.8181818,74 L31.8181818,52.1818182 C31.8181818,49.1709091 34.2618182,46.7272727 37.2727273,46.7272727 L42.7272727,46.7272727 C45.7381818,46.7272727 48.1818182,49.1709091 48.1818182,52.1818182 L48.1818182,74 L70,74 L70,44",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "57 13.4285714 57 8 70 8 70 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,38 L36.684,1.57134121 C38.7936,-0.523780402 42.21,-0.523780402 44.3196,1.57134121 L81,38",
    id: "Path"
  })))));
};
export default SvgFerienhaus;